var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('ConfigSystem')],1),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('System_config')],1),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('Api_connect')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }